import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../components/Context/AuthContext";
import API_URL from "../../config";
import {
  Container,
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Alert,
} from "@mui/material";
import { useLoading } from "../../components/LoadingContext/LoadingContext";
import API_BASE_URL from "../../utils/api";

const Signup = () => {
  const { setUser } = useContext(AuthContext);
  const [name, setName] = useState("");

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{8,}$/;

  const validatePassword = (password) => passwordRegex.test(password);
  const [passwordError, setPasswordError] = useState("");

  const navigate = useNavigate();
  const { setLoading, setLoadingMessage } = useLoading();

  const handleSignup = async (e) => {
    e.preventDefault();
    if (!validatePassword(password)) {
      setError(
        "Password must be at least 8 characters and include uppercase, lowercase, number, and special character."
      );
      setLoading(false);
      return;
    }

    setLoadingMessage("Creating your account.... This may take a few moments.");

    setLoading(true);

    try {
      const res = await axios.post(`${API_BASE_URL}/auth/signup`, {
        name,
        email,
        password,
      });

      setMessage(res.data.message);
      setTimeout(() => {
        setMessage("");
      }, 5000);
    } catch (err) {
      setError(err.response?.data?.error || "Signup failed. Try again.");
      setTimeout(() => {
        setError("");
      }, 5000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="xs">
      <Card sx={{ mt: 8, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h4" component="h2" align="center" gutterBottom>
            Sign Up
          </Typography>
          {message && <Alert severity="success">{message}</Alert>}
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}
          <Box
            component="form"
            onSubmit={handleSignup}
            sx={{ display: "flex", flexDirection: "column", gap: 2 }}
          >
            <TextField
              label="Name"
              type="text"
              variant="outlined"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              fullWidth
            />
            <TextField
              label="Email"
              type="email"
              variant="outlined"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              fullWidth
            />
            <TextField
              label="Password"
              type="password"
              variant="outlined"
              value={password}
              onChange={(e) => {
                const value = e.target.value;
                setPassword(value);

                if (!validatePassword(value)) {
                  setPasswordError(
                    "Password must be at least 8 characters and include uppercase, lowercase, number, and special character."
                  );
                } else {
                  setPasswordError("");
                }
              }}
              error={!!passwordError}
              helperText={passwordError}
              required
              fullWidth
            />
            <Button
              type="submit"
              variant="contained"
              color="primary"
              size="large"
              sx={{ mt: 1 }}
              disabled={
                !(
                  name.length > 0 &&
                  email.length > 0 &&
                  validatePassword(password)
                )
              }
            >
              Sign Up
            </Button>

            <Button
              variant="outlined"
              color="primary"
              sx={{ textTransform: "none", mt: 0 }}
              fullWidth
              onClick={() => navigate("/resend-verification")}
            >
              Didn't receive verification email?
            </Button>

            <Typography
              variant="body2"
              color="textSecondary"
              sx={{ textAlign: "center" }}
            >
              <Button
                variant="text"
                color="primary"
                sx={{ textTransform: "none" }}
                onClick={() => navigate("/sign-in")}
              >
                Already have an account?
              </Button>
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
};

export default Signup;
